import { createClient } from 'graphql-ws'

export const wsClient = createClient({
  url: 'wss://async-jobs-subscription-mkt-intel-beta.mercafacil.com/graphql',
  lazy: true,
})

export const wsClientHulk = createClient({
  url: process.env.VUE_APP_GRAPHQL_WS || 'wss://hulk-subscription.mercafacil.com/graphql',
  lazy: true,
})
